import React from "react";
import { Table } from "antd";

import "./TestInfoTable.css";

const TestInfoTable = ({ rowData, historyInfo }) => {
  const testInfoData = [
    {
      key: "test-info",
      test: rowData.analysis,
      category: rowData.test_category,
      result: rowData.result,
      specification: rowData.test_default_value,
      lowerBound: historyInfo.lower_bound,
      upperBound: historyInfo.upper_bound,
      message: historyInfo.message,
    },
  ];

  const testInfoColumns = [
    {
      title: "Test",
      dataIndex: "test",
      key: "test",
      render: (text) => text,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (text) => text,
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
      render: (text) => text,
    },
    {
      title: "Specification",
      dataIndex: "specification",
      key: "specification",
      render: (text) => text,
    },
    {
      title: "Lower Bound",
      dataIndex: "lowerBound",
      key: "lowerBound",
      render: (text) => text,
    },
    {
      title: "Upper Bound",
      dataIndex: "upperBound",
      key: "upperBound",
      render: (text) => text,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (text) => {
        const splitText = text ? text.split("\n").map((item, index) => <span key={index}>{item}</span>) : null;
        return <div className="sample-history-table-message">{splitText}</div>;
      },
    },
  ];

  return (
    <Table
      rowKey="key"
      columns={testInfoColumns}
      dataSource={testInfoData}
      pagination={false}
      bordered
      size="middle"
    />
  );
};

export default TestInfoTable;
